export default __webpack_public_path__ + "static/media/0.f832945a.png";